import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Field, getId } from '../Field/Field';
import { FieldError } from '../Field/FieldError';
import { formErrorAttribute } from '../Form/FormWithValidation';
import { useInputContext } from '../Form/withInputContext';
import { useTranslate } from '../util';
import { Hint } from './Hint';
import { StyledNumberInput, StyledUnitsLabel } from './NumberInput.styled';
import { StyledTextInputWrapper } from './TextInput.styled';
export var NUMBER_INPUT_MAX_LENGTH = 15;
export function NumberInput(props) {
  var t = useTranslate();
  var inputContext = useInputContext({
    forceShowValidation: props.forceShowValidation
  });
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    invalidNumberWarning = _React$useState2[0],
    setInvalidNumberWarning = _React$useState2[1];
  var valueIsNull = props.value == null || props.value < 0;
  var requiredError = props.required && valueIsNull && t('citrix-ui:validation.enter_required_value');
  var minValueError = props.minValue != null && !valueIsNull && props.value != null && props.value < props.minValue && t('citrix-ui:validation.enter_greater_value', {
    value: props.minValue
  });
  var maxValueError = props.maxValue && props.value && props.value != null && props.value > props.maxValue && t('citrix-ui:validation.enter_smaller_value', {
    value: props.maxValue
  });
  var isErrored = !props.disabled && (!!props.errorMessage || !!requiredError || !!minValueError || !!maxValueError);
  var showError = inputContext.isDirty && isErrored;
  var showWarning = !props.disabled && (inputContext.isDirty && !!props.warningMessage || !!invalidNumberWarning);
  var width = props.width || '100px';
  var textAlign = props.textAlign || 'center';
  return /*#__PURE__*/React.createElement(StyledTextInputWrapper, null, /*#__PURE__*/React.createElement(StyledNumberInput, _extends({
    type: "tel",
    id: props.id,
    showError: showError,
    showWarning: showWarning,
    width: width,
    textAlign: textAlign,
    maxLength: props.maxLength,
    autoFocus: !!props.autoFocus,
    placeholder: props.placeholder,
    autoComplete: props.autoComplete,
    value: props.value == null || props.value < 0 ? '' : props.value.toString(),
    onBlur: onBlur,
    disabled: !!props.disabled,
    onChange: onChange,
    "aria-label": props['aria-label'],
    "aria-labelledby": props['aria-labelledby']
  }, formErrorAttribute(isErrored))), props.units && /*#__PURE__*/React.createElement(StyledUnitsLabel, null, props.units), /*#__PURE__*/React.createElement(FieldError, {
    error: showError ? requiredError || minValueError || maxValueError || props.errorMessage : undefined,
    warning: showWarning ? invalidNumberWarning || props.warningMessage : undefined,
    htmlFor: props.id
  }), /*#__PURE__*/React.createElement(Hint, {
    hint: props.hint
  }));
  function onChange(e) {
    if (props.validateOnChange) {
      inputContext.makeDirty();
    }
    var value = e.currentTarget.value.trim();
    var isValid = !!value.match(/^\d*$/);
    setInvalidNumberWarning(!isValid ? t('citrix-ui:validation.enter_valid_digit') : '');
    if (isValid && props.maxLength && value.length <= props.maxLength) {
      props.onChange && props.onChange(value ? parseInt(value, 10) : -1);
    }
  }
  function onBlur() {
    var _props$onBlur;
    inputContext.makeDirty();
    (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props);
  }
}
NumberInput.defaultProps = {
  maxLength: NUMBER_INPUT_MAX_LENGTH
};
export function NumberField(props) {
  var id = getId(props);
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id
  }), /*#__PURE__*/React.createElement(NumberInput, _extends({}, props, {
    id: id
  })));
}